import { render, staticRenderFns } from "./AnswerTypeEssay.vue?vue&type=template&id=32a67014"
import script from "./AnswerTypeEssay.vue?vue&type=script&lang=js"
export * from "./AnswerTypeEssay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports